import GeneralAndNarrowAi from "./components/GeneralAndNarrowAi";
import PatternTable from "./components/PattranTable";

export type PluginType = {
  name: string;
  component: (props: any) => JSX.Element;
  description: string;
  defaultProps: any;
};

export default [
  {
    name: "Chatbot",
    component: GeneralAndNarrowAi,
    description: "Chat bot which supports narrow, general, rule based support",
    defaultProps: {
      aiName: "Luna 🌓",
      prompts: ["What’s the capital of France?"],
      system:
        "You are a chess-only AI. Give short one-line answers. If it's not about chess, say 'I can't help with that.'",
      color: "purple",
      topPanel: true,
    },
  },
  {
    name: "PatternTable",
    component: PatternTable,
    description: "Pattern reconized table",
    defaultProps: {
      data: [
        { x: 2, y: 3 },
        { x: 3, y: 5 },
        { x: 4, y: 7 },
      ],
      showInput: true,
      question: "",
    },
  },
];
